module.exports = __webpack_public_path__ + "static/media/wowo-logo-word-full.7a803527.svg";